import request from "@/util/axios";
import store from "@/store";

export function getSysConfigValue(configName) {
  return request({
    url: "/mall/wx/wx-user-get-config-value",
    params: { configName },
  });
}

export function getDictItems(dictCode) {
  return request({
    url: "/mall/wx/wx-user-getDictItems",
    params: { dictCode },
  });
}

export function getMovieIndexUrl(cityCode, poi) {
  return request({
    url: "/mall/wx/movie/getIndexUrl",
    params: { cityCode, poi },
  });
}

export function getHelpList(cate) {
  return request({
    url: "/mall/wx/UserCenter/get-help-list",
    params: { cate },
  });
}

export function getBrandShopListById(brandId) {
  return request({
    url: "/mall/wx/Goods/get-brand-shop-list-by-id",
    params: { brandId, cityCode: store.getters.city_code },
  });
}
